import React, { useEffect, useState } from 'react';
import { DiscoveryEntry, facetSearchUrl, fetchDiscovery } from '../services/discovery';
import { useContent } from '../contexts/ContentContext';
import { getConfig } from '../config';
import DiscoveryCandidates from './DiscoveryCandidates';
import PopularImagesSection from './PopularImagesSection';

export default function DiscoveryLinks({ expanded = false }: { expanded?: boolean }) {
    const { t } = useContent();
    const [entries, setEntries] = useState<DiscoveryEntry[]>([]);
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        if (expanded) return;
        let active = true;
        setError(false);
        fetchDiscovery().then(value => { if (active) setEntries(value); }).catch(() => { if (active) setError(true); });
        return () => { active = false; };
    }, [attempt, expanded]);
    if (!entries.length && !expanded) return null;
    return <section className={`lab-discovery ${expanded ? 'lab-discovery-expanded' : ''}`} aria-label={t(expanded ? 'discovery.expandedTitle' : 'discovery.title')}>
        <h2>{t(expanded ? 'discovery.expandedTitle' : 'discovery.title')}</h2>
        {expanded && <PopularImagesSection home />}
        {error && <p role="alert">{t('search.error')} <button className="lab-button" onClick={() => setAttempt(value => value + 1)}>{t('common.retry')}</button></p>}
        {!expanded && <nav className="lab-discovery-cards">{entries.map(entry => <a key={entry.group + entry.slug} href={facetSearchUrl(entry.group, entry.slug)}>
            <img src={new URL(entry.image.thumb, new URL(getConfig().apiBaseUrl).origin).href} alt="" loading="lazy" onError={() => setEntries(values => values.filter(value => value !== entry))} />
            <span><small>{t(`search.group.${entry.group}`)}</small><strong>{entry.label}</strong></span>
        </a>)}</nav>}
        {expanded && <DiscoveryCandidates />}
    </section>;
}
